import { OrganizationUserEntity } from '../entities';
import { authResource } from './Auth';
import { paginatedSchema } from '../utils/schemas';
export const OrganizationAdministratorsResource = authResource({
    path: '/organizations/:organizationId/administrators/:userId?',
    searchParams: {},
    schema: OrganizationUserEntity
})
    .extend('getList', {
    schema: paginatedSchema(OrganizationUserEntity)
})
    .extend((BaseResource) => ({
    delete: BaseResource.delete.extend({
        schema: undefined
    })
}));
